import { useEffect, useState } from "react";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { getIdTokenResult } from "firebase/auth";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../firebase/config";

/** True only when `users/{uid}` has an explicit `isOneToOne: false` (missing field ⇒ not locked). */
function isSessionsBookingLocked(userData) {
  if (!userData || typeof userData !== "object") return false;
  return (
    Object.prototype.hasOwnProperty.call(userData, "isOneToOne") &&
    userData.isOneToOne === false
  );
}

const useUserRole = () => {
  const [user, setUser] = useState(null);
  const [pseudo, setPseudo] = useState(null);
  const [role, setRole] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [score, setScore] = useState();
  const [sessionsBookingLocked, setSessionsBookingLocked] = useState(false);

  useEffect(() => {
    const auth = getAuth();
    const unsubscribe = onAuthStateChanged(auth, async (currentUser) => {
      if (currentUser) {
        try {
          const docRef = doc(db, "users", currentUser.uid)
          const snap = await getDoc(docRef);
          const userData = snap.exists() ? snap.data() : {};
          setScore(userData.totalScore || 0)
          setPseudo(userData.pseudo || currentUser.email.split('@')[0])
          setSessionsBookingLocked(isSessionsBookingLocked(userData));
          setUser(currentUser);

          const tokenResult = await getIdTokenResult(currentUser);
          const claims = tokenResult.claims;
          if (claims?.isAdmin) {
            setRole("admin");
          } else {
            setRole("user");
          }
        } catch (err) {
          setError(err);
        }
      } else {
        setUser(null);
        setRole(null);
        setSessionsBookingLocked(false);
      }
      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  return { user, role, loading, error, score, pseudo, sessionsBookingLocked };
};

export default useUserRole;
